import { render } from "./InternetService.vue?vue&type=template&id=41ddb635"
import script from "./InternetService.vue?vue&type=script&lang=js"
export * from "./InternetService.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "41ddb635"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41ddb635', script)) {
    api.reload('41ddb635', script)
  }
  
  module.hot.accept("./InternetService.vue?vue&type=template&id=41ddb635", () => {
    api.rerender('41ddb635', render)
  })

}

script.__file = "src/views/services/modules/internet/InternetService.vue"

export default script